export const customerMixin = {
   data: function(){
      return {
         customers: {}
      }
   },
   computed: {

   },
   methods: {
      getCustomers: function(clientId){
         const url = (clientId) ? `customer/${clientId}/list` : 'customer';
         this.$http.get(url).then(res => {
            this.customers = res.data.obj;
         });
      },
      findInCustomers: function(key, val){
         for (let i in this.customers) {
            let customer = this.customers[i];
            if(customer[key] == val) {
               return true;
            }
         }
         return false;
      },
      deleteCustomer: function(customer){
         this.$socket.emit('customerDelete', customer);
      }
   },
   sockets: {

   }
};


// WEBPACK FOOTER //
// ./src/Banet/mixins/customerMixin.js